<template>
  <MyLayout>
    <router-view></router-view>
  </MyLayout>
</template>

<script>
import MyLayout from '@/components/Layout/index';
export default {
  components: {
    MyLayout,
  },
};
</script>
